import { Input, InputProps } from 'antd';

const InputForm = (props: InputProps) => {
  return (
    <Input
      allowClear
      size="large"
      className={`${props.className} w-full`}
      {...props}
    />
  );
};

export default InputForm;
